import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BarcodeScanner } from '@app/src/app/barcodeScanner';

import { SystemAlertSnackBarService } from '@shared/components/system-alert-snackbar';

import { PeopleSelectorService } from '../people-selector.service';
import { PeopleSelectorFormService } from '../ps-form.service';
import { PsCollectionSearchImplService } from '../search-impl/ps-collection-search.impl.service';

@Injectable()
export class PsStandAloneService extends PeopleSelectorFormService<'Standalone'> {
  /** Service Constructor */
  constructor(
    public router: Router,
    public snackbar: SystemAlertSnackBarService,
    public barCodeScanner: BarcodeScanner,
    public peopleSelector: PeopleSelectorService,
    private _psCollectionSearch: PsCollectionSearchImplService,
  ) {
    super(
      {
        name: 'Standalone',
        pageDefinitions: {
          select: {
            submitFn: async => this.submitSelection(),
            searchFn: async => this._psCollectionSearch.collectionSearch('text', undefined),
          },
        },
      },
      router,
      snackbar,
      barCodeScanner,
      peopleSelector,
    );
    this.setConfig({
      name: 'Standalone',
      pageDefinitions: {
        select: {
          submitFn: async () => this.submitSelection(),
          searchFn: async (type, filters) => this._psCollectionSearch.collectionSearch(type, filters),
        },
      },
    });
  }

  public async submitSelection(): Promise<void> {
    const selection = this.selection.getSelection();
    this.peopleSelector.close();
    this.data.resultSubject.next(selection);
  }
}
